export default "__VITE_ASSET__DCA7XC6A__"